<template>
    <div>
        <h1 style="text-align: center;">Image Component Editor</h1>
        <div v-if="isLoading" class="loading">PLEASE WAIT...</div>
        <div>
            <div ref="cntTitle">
                <h2>Title</h2>
                <div><input type="text" v-model="title" style="width: 100%"></div>
            </div>
            <div ref="cntThumb">
                <h2>Thumbnail</h2>
                <div><img :src="thumbnail.data" height="200px" width="100%" style="object-fit: contain;"></div>
                <div><input type="file" v-on:change="changeImage(thumbnail, $event)" accept="image/jpeg,image/png,image/tif" style="width: 100%; color: black;"></div>
            </div>
            <div style="display: flex; flex-direction: column;margin-top: 1em;">
                <div v-for="(map,mi) in data" :key="'MAP_KEY' + mi" :ref="'cntMap-' + mi" style="margin-bottom: 1em; padding: 5px; border: 2px solid white; border-radius: 5px; background: rgba(0,0,0,0.5);">
                    <h1 style="text-align: center;">Map #{{mi+1}} <input type="text" v-model="map.title" placeholder="Map title!"> <small @click="deleteMap(mi)" style="cursor: pointer; background: red; color: white;border-radius: 5px;">🗑</small></h1>
                    <div :ref="'cntMapImg-' + mi">
                        <h2>Image</h2>
                        <div><img :src="map.background.data" height="200px" width="100%" style="object-fit: contain; background: black;"></div>
                        <div><input type="file" v-on:change="changeImage(map.background, $event)" accept="image/jpeg,image/png,image/tif" style="width: 100%; background: black;"></div>
                    </div>
                    <hr>
                    <div style="display: flex; flex-flow: row wrap;">
                        <div v-for="(entry,ei) in map.entries" :key="'ENTRY-' + mi + '-' + ei" :ref="'cntEntry-' + mi + '-' + ei" style="position: relative;display: flex; flex: 50%; flex-direction: column; text-align: center;align-items: center; border-radius: 7px; border: 1px solid white; padding: 0.7em;">
                            <h2 @click="deleteEntry(mi, ei)" style="cursor: pointer; background: red; color: white;border-radius: 5px; position: absolute; top: 0.25em; right: 0.25em; padding: 0.2em;">🗑</h2>
                            <Minimap :img="map.background.data" :x="entry.position.y" :y="entry.position.x"></Minimap>
                            <span style="width: 100%;">
                                X: <input type="range" min="0" max="550" v-model="entry.position.x" style="width: 400px;">
                                <input type="text" v-model="entry.position.x" style="width: 40px;">
                            </span>
                            <span style="width: 100%;">
                                Y: <input type="range" min="0" max="750" v-model="entry.position.y" style="width: 400px;">
                                <input type="text" v-model="entry.position.y" style="width: 40px;">
                            </span>
                            <span>
                                <input type="text" v-model="map.entries[ei].label" placeholder="Label..." style="width: 400px;">
                            </span>
                        </div>
                    </div>
                    <button @click="addNewEntry(mi)" style="width: 100%; background: green; color: white;">Add New Entry</button>
                </div>
            </div>
            <div>
                <button @click="addNewMap()" class="submit-btn">Add New Map</button>
                <button @click="submitThis()" class="submit-btn">Submit</button>
            </div>
        </div>
    </div>
</template>

<script>
import {Functions} from './functions.js';
import Minimap from './minimap.vue';

export default {
    name: "Infographic4AddEditComponent",
    props: ['ID'],
    components:{Minimap},
    data: () => ({
        isLoading: true,
        title: "",
        thumbnail: {
            file: undefined,
            data: "",
            publicUrl: "",
            uploadUrl: ""
        },
        data: [],
        functions: undefined,
    }),
    mounted: function(){
        this.functions  = new Functions();
        if(this.ID){
            console.log("EDITING");
            this.functions.getComponent(this.ID, (data) => {
                console.log(data);
                this.id = data.contentId;
                this.title = data.title;
                this.thumbnail.publicUrl = data.rdsDat[0].Thumbnail;
                this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, "image/jpeg,image/png,image/tif", "getObject", (thumbBuff) => {
                    this.thumbnail.data = (thumbBuff.signedUrl);
                    this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, "image/jpeg,image/png,image/tif", "putObject", (thumbBuff1) => {
                        this.thumbnail.uploadUrl = thumbBuff1.signedUrl;
                        this.getMapSignedURL(0, data.data);
                    });
                });
            });
        }else{
            this.functions.getThumbURL((dat) => {
                this.thumbnail.publicUrl = dat.key;
                this.thumbnail.uploadUrl = dat.signedUrl;
                this.addNewMap();
            });
        }
    },
    methods: {
        getMapSignedURL: function(i, data){
            if(i >= data.length){
                this.isLoading = false;
                return null;
            }
            this.data.push({
                    background: {
                        file: undefined,
                        data: data[i].background,
                        publicUrl: data[i].background,
                        uploadUrl: ""
                    },
                    title: data[i].title,
                    entries: data[i].entries
            });
            this.functions.getSignedUrl("ttedu-public-uploads", data[i].background.replace("https://ttedu-public-uploads.s3.amazonaws.com/", ""), "image/jpeg,image/jpg,image/png,image/tif", "putObject", (dat) => {
                this.data[i].background.uploadUrl = dat.signedUrl;
                this.getMapSignedURL(i+1, data);
            });
        },
        addNewMap: function(){
            this.isLoading = true;
            this.functions.getImageURL((dat) => {
                this.data.push({
                    background: {
                        file: "",
                        data: "",
                        publicUrl: dat.key,
                        uploadUrl: dat.signedUrl
                    },
                    title: "",
                    entries: []
                });
                this.addNewEntry(this.data.length-1);
            });
        },
        addNewEntry: function(i){
            this.isLoading = true;
            this.data[i].entries.push({
                label: "",
                position: {
                    x: 0,
                    y: 0
                }
            });
            this.isLoading = false;
        },
        changeImage: function(ob, e){
            // console.log(ob, e.target.files[0]);
            var reader = new FileReader();
            reader.onload = (e) => {
                ob.data = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);
            ob.file = e.target.files[0];
        },
        submitThis: function(){
            let hasError = false;
            this.isLoading = true;
            //validations
            if(this.title.trim() == ""){
                this.$refs.cntTitle.classList.add("has-error");
                hasError = true;
            }else this.$refs.cntTitle.classList.remove("has-error");

            if(this.ID == undefined){
                if(this.thumbnail.file == undefined){
                    this.$refs.cntThumb.classList.add("has-error");
                    hasError = true;
                }else this.$refs.cntThumb.classList.remove("has-error");
                this.data.forEach((map, mi) => {
                    if(map.background.file == undefined){
                        this.$refs["cntMapImg-" + mi][0].classList.add("has-error");
                    }else this.$refs["cntMapImg-" + mi][0].classList.remove("has-error");
                });
            }

            this.data.forEach((map, mi) => {
                map.entries.forEach((entry, ei) => {
                    if(entry.label.trim() == ""){
                        this.$refs["cntEntry-" + mi + "-" + ei][0].classList.add("has-error");
                    }else this.$refs["cntEntry-" + mi + "-" + ei][0].classList.remove("has-error");
                });
            });
            if(!hasError){
                //No errors
                let componentData = {
                    ContentType: "INTERACTIVE",
                    Title: this.title,
                    Thumbnail: this.thumbnail.publicUrl,
                    Component: "infographic4",
                    Data: JSON.parse(JSON.stringify(this.data))
                };
                componentData.Data.forEach((map, mi) => {
                    map.background = map.background.publicUrl;
                });
                console.log("componentData",componentData);
                // return null;
                if(this.ID){
                    //update component.
                    if(this.thumbnail.file == undefined){
                        this.uploadMaps(0, componentData);
                    }else{
                        this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                            this.uploadMaps(0, componentData);
                        });
                    }
                }else{
                    //create new component.
                    console.log("No errors, proceeding to upload");
                    this.isLoading = true;
                    this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                        this.uploadMaps(0, componentData);
                    });
                }
            }else{
                alert("Please fix all the errors");
            }
        },
        uploadMaps: function(i, componentData){
            console.log("uploadMaps", componentData);
            if(i < this.data.length){
                //upload map
                if(this.data[i].background.file != undefined){
                    //upload
                    console.log("UPLOADING:", this.data[i].background.file);
                    console.log("url:" ,this.data[i].background.uploadUrl);
                    this.functions.upload(this.data[i].background.uploadUrl, this.data[i].background.file, (dat) => {
                        this.uploadMaps(i+1, componentData);
                    });
                }else{
                    this.uploadMaps(i+1, componentData);
                }
            }else{
                //upload Data
                if(this.ID){
                    this.functions.updateComponent(this.ID, componentData, (dat) => {
                        console.log(dat);
                        this.$router.push("/editors/component/infographic4");
                    });
                }else{
                    this.functions.addComponent(componentData, (dat) => {
                        console.log(dat);
                        this.$router.push("/editors/component/infographic4");
                    });
                }
            }
        },
        deleteMap: function(i){
            let c = confirm("Are you sure you want to delete Map #" + (i+1));
            if(c){
                this.data.splice(i, 1);
            }
        },
        deleteEntry: function(mi, ei){
            let c = confirm("Are you sure you want to delete Map #" + (mi+1) + "'s Entry #" + (ei+1));
            if(c){
                this.data[mi].entries.splice(ei, 1);
            }
        }
    }
};
</script>


<style>
    hr{
        border: solid 2px white;
    }
    h2{
      color: black;
    }
    .quill-editor{
        background: white;
        color: black;
    }
    .ql-container.ql-snow{
        background: white !important;
    }
    .submit-btn{
        width: 100%;
        height: 2em;
        font-size: 1.5em;
        font-weight: 800;
        margin-top: 0.5em;
    }
    .has-error{
        border: red 5px solid !important;
        box-sizing: border-box;
    }
    .has-error::after{
        content: "Missing content/invalid content.";
        color: red;
        background: white;
        font-weight: 800;
    }
    .loading{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        vertical-align: middle;
        justify-content: center;
        text-align: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        display: flex;
        font-size: 4em;
        font-weight: 900;
    }
    .minimap img{
        object-fit: fill !important;
    }
</style>